module.exports = __webpack_public_path__ + "static/img/nagam cropped.94e2d47.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nagam cropped.jpeg
// module id = ZqlH
// module chunks = 1